import { NavLink, useNavigate } from 'react-router-dom';

import { Avatar } from '@/components/ui/Avatar';
import { useAuthStore } from '@/stores/authStore';
import { authApi } from '@/lib/api';
import { cn } from '@/lib/utils';

const items = [
  { to: '/admin', label: 'Tableau de bord', icon: '▦', end: true },
  { to: '/admin/menus', label: 'Menus', icon: '▥' },
  { to: '/admin/candidates', label: 'Candidats', icon: '✦' },
  { to: '/admin/orders', label: 'Commandes', icon: '◉' },
  { to: '/admin/clients', label: 'Clients', icon: '●' },
  { to: '/admin/ambassadeurs', label: 'Ambassadeurs', icon: '◈' },
  { to: '/admin/payments', label: 'Paiements', icon: '⬢' },
  { to: '/admin/settings', label: 'Réglages', icon: '⚙' },
];

export function AdminSidebar() {
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();

  const onLogout = async () => {
    try {
      await authApi.logout();
    } catch {
      /* logout-best-effort */
    }
    clear();
    navigate('/login');
  };

  return (
    <aside className="flex w-60 shrink-0 flex-col gap-1 border-r border-line bg-paper px-4 py-12 dark:border-d-line dark:bg-d-card">
      <div className="mb-3 border-b border-line px-2.5 pb-5 dark:border-d-line">
        <div className="mono text-[10px] font-bold tracking-[2px] text-muted">ADMIN</div>
        <div className="font-display text-2xl font-extrabold leading-none text-orange">My Food+</div>
      </div>

      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.end}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors',
              isActive
                ? 'bg-orange text-white'
                : 'text-ink-soft hover:bg-cream-2 dark:text-d-ink dark:hover:bg-d-line',
            )
          }
        >
          <span className="w-5 text-center text-base" aria-hidden>
            {it.icon}
          </span>
          {it.label}
        </NavLink>
      ))}

      <div className="mt-auto flex items-center gap-2.5 rounded-xl bg-black/5 p-3 dark:bg-white/5">
        <Avatar name={user ? `${user.prenom} ${user.nom}` : 'CG'} color="#F97316" size="md" />
        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-semibold">
            {user ? `${user.prenom} ${user.nom}` : 'Cedric G.'}
          </div>
          <div className="text-[10px] text-muted">Administrateur</div>
        </div>
        <button
          onClick={onLogout}
          className="rounded-lg p-1.5 text-muted hover:bg-black/5 dark:hover:bg-white/5"
          aria-label="Se déconnecter"
          title="Se déconnecter"
        >
          ⏻
        </button>
      </div>
    </aside>
  );
}
